import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResp } from 'src/app/core/models/page/page-response';
import { environment } from 'src/environments/environment';
import { UserGroupSubscriptionData } from '../interface/user-group-subscription-data';

@Injectable({
  providedIn: 'root'
})
export class UserGroupSubscriptionMaintenanceService {

  constructor(private http: HttpClient) { }

  getTenantMappingUserGroup(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/notify/getTenantMappingUserGroup`;
    return this.http.post(url, null);
  }

  getTenantMappingUserGroupDetail(tenantMappingUserGroupSeqNo: any): Observable<any> {
    const httpOptions = {
      params: {
        "tenantMappingUserGroupSeqNo": tenantMappingUserGroupSeqNo.toString(),
      },
    };
    const url = `${environment.logisticsApiUrl}/notify/getTenantMappingUserGroupDetail`;
    return this.http.post(url, null, httpOptions);
  }

  searchUserGroupSubscription(req: any): Observable<PageResp<UserGroupSubscriptionData>> {
    const url = `${environment.logisticsApiUrl}/notify/getUserGroupSubscriptionData`;
    return this.http.post<PageResp<UserGroupSubscriptionData>>(url, req);
  }
  
  getUserGroupSubscriptionExcel(req: any): Observable<Blob> {
    const url = `${environment.notificationUrl}/notifyEvent/getUserGroupSubscriptionExcel`;
    return this.http.post(url, req, { responseType: 'blob' });
  }

  saveUserGroupSubscription(req: any): Observable<any> {
    const url = `${environment.notificationUrl}/notifyEvent/saveUserGroupSubscriptionData`;
    return this.http.post(url, req);
  }

  changeUserGroupSubscriptionIsActivated(seqNo: string, isActivated: string): Observable<any> {
    const httpOptions = {
      params: {
        "seqNo": seqNo,
        "isActivated": isActivated
      },
    };
    const url = `${environment.logisticsApiUrl}/notify/changeUserGroupSubscriptionIsActivated`;
    return this.http.post(url, null, httpOptions);
  }
}
